export default "__VITE_ASSET__D3FZJK75__"